<div class="d-flex align-items-end">
    <div class="d-flex flex-column align-items-center mr-2 new-position__container">
        <div class="new-position__label">New Position</div>
        <input
            class="input--move"
            currencyMask
            [options]="{ align: 'center', allowNegative: false, prefix: '', inputMode: 1 }"
            [formControl]="control"
        />
    </div>
    <button class="btn btn--paybee btn--move btn--move-to" (click)="moveTo()">Move</button>
</div>